<section class="section--public background--wave">
  <div appInfiniteScroll (needToScroll)="scroll()" class="component-container">
    <div class="relative">
      <app-featured-testimonies-slider
        *ngIf="languageService.sliderFeaturedTestimoniesIsEnabled"
        class="mb-8 block"
      ></app-featured-testimonies-slider>
      <app-error-tooltip
        *ngIf="componentStore.error$ | async as error"
        [error]="error"
      ></app-error-tooltip>
      <ng-container *ngIf="componentStore.entities$ | async as testimonies">
        <app-testimonies-grid [testimonies]="testimonies"></app-testimonies-grid>
        <app-no-results
          *ngIf="(componentStore.loaded$ | async) && !testimonies.length"
        ></app-no-results>
      </ng-container>
      <app-loader-infinite-scroll
        [loading$]="componentStore.loading$"
        [scrolling$]="componentStore.scrolling$"
      ></app-loader-infinite-scroll>
    </div>
  </div>

  <app-public-footer></app-public-footer>
</section>
